import React from 'react';

import { Button, DialogActions, Stack } from '@mui/material';

import { RATE_PLAN_FORM_ID } from './RatePlanStep/utils';
import { PROPERTY_FORM_ID, STEPS, TAXES_FEES_FORM_ID } from './constants';

interface Props {
  activeStep: number;
  contentPageUrl: string;
  isContentStep: boolean;
  isCreatePropertyStep: boolean;
  isPropertyStepNextDisabled: boolean;
  isRatePlanStep: boolean;
  isRatePlanStepNextDisabled: boolean;
  isRoomRateCapacityStepNextDisabled: boolean;
  isRoomRatesStepNextDisabled: boolean;
  isRoomStepNextDisabled: boolean;
  isStepBusy: boolean;
  isTaxesAndFeesStep: boolean;
  onGoToContentPage: () => void;
  onNext: () => void;
  onPrevious: () => void;
  primaryButtonLabel: string;
  ratePlanCreated: boolean;
  trimmedSalesforceOfferId: string;
}

export default function WizardActions({
  activeStep,
  contentPageUrl,
  isContentStep,
  isCreatePropertyStep,
  isPropertyStepNextDisabled,
  isRatePlanStep,
  isRatePlanStepNextDisabled,
  isRoomRateCapacityStepNextDisabled,
  isRoomRatesStepNextDisabled,
  isRoomStepNextDisabled,
  isStepBusy,
  isTaxesAndFeesStep,
  onGoToContentPage,
  onNext,
  onPrevious,
  primaryButtonLabel,
  ratePlanCreated,
  trimmedSalesforceOfferId,
}: Props) {
  const submitsCurrentStep = isCreatePropertyStep || (isRatePlanStep && !ratePlanCreated) || isTaxesAndFeesStep;

  return (
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button onClick={onPrevious} disabled={activeStep === 0 || isContentStep || isStepBusy}>
        Previous
      </Button>
      <Stack direction="row" spacing={1}>
        {activeStep === STEPS.length - 1 ? (
          <Button variant="contained" onClick={onGoToContentPage} disabled={!contentPageUrl}>
            Go to content page
          </Button>
        ) : (
          <Button
            variant="contained"
            form={
              isCreatePropertyStep
                ? PROPERTY_FORM_ID
                : isRatePlanStep && !ratePlanCreated
                  ? RATE_PLAN_FORM_ID
                  : isTaxesAndFeesStep
                    ? TAXES_FEES_FORM_ID
                    : undefined
            }
            type={submitsCurrentStep ? 'submit' : 'button'}
            onClick={submitsCurrentStep ? undefined : onNext}
            disabled={
              (activeStep === 0 && !trimmedSalesforceOfferId) ||
              isStepBusy ||
              isPropertyStepNextDisabled ||
              isRatePlanStepNextDisabled ||
              isRoomStepNextDisabled ||
              isRoomRatesStepNextDisabled ||
              isRoomRateCapacityStepNextDisabled
            }
          >
            {primaryButtonLabel}
          </Button>
        )}
      </Stack>
    </DialogActions>
  );
}
